// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"235":"ff517102","589":"b3552e53"}[chunkId] + ".chunk.js";
};